import { FC } from 'react';

import dayjs from 'dayjs';
import {
  Area,
  AreaChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { IReportPayment } from 'types';

import { CustomActiveDotLine } from './CustomActiveDotLine';
import { CustomAxisTick } from './CustomAxisTick';
import { CustomTooltip } from './CustomTooltip';

export interface IPaymentsChartProps {
  data: Array<IReportPayment>;
}
export const Chart: FC<IPaymentsChartProps> = ({ data }) => {
  const firsPaymentDate = data[0]?.created_at;
  const lastPaymentDate = data[data.length - 1]?.created_at;

  return (
    <ResponsiveContainer height={300}>
      <AreaChart data={data}>
        <defs>
          <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
            <stop
              offset="5%"
              stopColor="var(--icon-link-info)"
              stopOpacity={0.5}
            />
            <stop
              offset="100%"
              stopColor="var(--icon-link-info)"
              stopOpacity={0}
            />
          </linearGradient>
        </defs>
        <ReferenceLine
          x={firsPaymentDate}
          stroke="var(--text-secondary)"
          strokeDasharray="3 3"
        />
        <ReferenceLine
          x={lastPaymentDate}
          stroke="var(--text-secondary)"
          strokeDasharray="3 3"
        />
        <XAxis
          type="number"
          dataKey="created_at"
          axisLine={false}
          tickLine={false}
          tickCount={3}
          domain={['dataMin', 'dataMax']}
          tickFormatter={(value) => dayjs(value).format('DD.MM HH:mm')}
          tick={<CustomAxisTick isXAxis firstPaymentTime={firsPaymentDate} />}
          padding={{ left: 8 }}
        />
        <YAxis
          type="number"
          dataKey="total"
          tickLine={false}
          axisLine={false}
          tickFormatter={(value) => `${value.toLocaleString()}`}
          tick={<CustomAxisTick />}
        />

        <Tooltip
          cursor={<CustomActiveDotLine />}
          isAnimationActive={false}
          content={({ payload }) => {
            return <CustomTooltip payment={payload?.[0]?.payload} />;
          }}
        />
        <Area
          type="monotone"
          dataKey="total"
          stroke="var(--icon-link-info)"
          fillOpacity={1}
          fill="url(#gradient)"
          activeDot={{ stroke: 'var(--bg-blue-10)', strokeWidth: 4, r: 2 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};
